/* eslint-disable radix,no-case-declarations,default-case,no-restricted-syntax */
import { uuid } from 'vue-uuid';
import EventBus from '@/EventBus';
import store from '@/store';

export default class TextObject {
    /**
     * Method 1: Init
     * Method 2: InitFromXML
     * Method 3: GetHTML
     * Method 4: GetXML
     * Method 5: CloneObject
     * Method 6: InitFromHTML
     */

    // OldValue
    // data= {
    //   AllowMove:           'true',
    //   AllowResize:         'true',
    //   AllowRotate:         'true',
    //   ColorSystem:         'CMYK',
    //   ColorType:           'NotAvailable',
    //   DefaultColor:        'cmyk(0% 0% 0% 0%)',
    //   Font:                'Ubuntu',
    //   FontSize:            5,
    //   Height:              261.3,
    //   HorizontalAlign:     'center',
    //   Id:                  '3ce30d3c-7dfa-4a03-8b07-992fec72a7c8',
    //   InputType:           'Textarea',
    //   IsBold:              false,
    //   IsHFlipped:          false,
    //   IsHtml:              true,
    //   IsItalic:            false,
    //   IsUnderLine:         false,
    //   IsVFlipped:          false,
    //   IsVisible:           true,
    //   LayerPanelValue:     false,
    //   LineSpacing:         '4',
    //   lineHeight:          '1.5',
    //   color:               'rgb(255,255,255)',
    //   ListValues:          null,
    //   Name:                'Body',
    //   PageNo:              '1',
    //   PdfSortOrder:        104,
    //   RotateDegree:        0,
    //   RotateX:             0,
    //   RotateY:             0,
    //   SelctedColorValueId: '0d1b6074-5d82-41ed-acc3-9c8026781c41',
    //   SelectedColorId:     '00000000-0000-0000-0000-000000000000',
    //   Size:                '250',
    //   SortOrder:           '1',
    //   UseRgb:              false,
    //   Value:               'Enter Text Here...',
    //   VerticalAlign:       'Middle',
    //   Width:               552,
    //   X:                   30,
    //   Y:                   407,
    //   elementIndex:        -1,
    //   editor:              null,
    //   locked:              false,
    //   type:                'text',
    //   name:                 'Text',
    //   scaleX:              1,
    //   scaleY:              1,
    //   alignLeft:           false,
    //   alignCenter:         false,
    //   alignRight:          false,
    //   isBulletList:        false,
    //   isNumberList:        false,
    //   isSubScript:         false,
    //   isSupperScript:      false,
    //   isJustify:           false,
    //   isParentBold:        false,
    //   isParentItalic:      false,
    //   parentFontFamily:    'Open Sans',
    //   parentFontSize:      1,
    //   parentColor:         'black',
    //   isParentUnderline:   false,
    //   isEditorEnable:      false,
    //   HTML:                null,
    //   isSelected:          false,
    //   isEditableForRightPanel: false,
    //   valuesForLeftPanel:  {
    //     fontFamily:      'none',
    //     fontSize:        16,
    //     lineSpacing:     0,
    //     color:           'black',
    //     isBold:          false,
    //     isItalic:        false,
    //     isUnderline:     false,
    //     horizontalAlign: 'center',
    //     verticalAlign:   'Middle',
    //     isJustify:       false,
    //     isBulletList:    false,
    //     isNumberList:    false,
    //     isSubScript:     false,
    //     isSupperScript:  false,
    //   },
    // }


    data= {
      AllowMove:               'true',
      AllowResize:             'true',
      AllowRotate:             'true',
      ColorSystem:             'CMYK',
      DefaultColor:            'cmyk(0% 0% 0% 0%)',
      Height:                  261.3,
      Id:                      '3ce30d3c-7dfa-4a03-8b07-992fec72a7c8',
      IsHtml:                  true,
      IsVisible:               true,
      Name:                    'Body',
      PageNo:                  '1',
      PdfSortOrder:            104,
      RotateDegree:            0,
      RotateX:                 0,
      RotateY:                 0,
      SortOrder:               '1',
      Value:                   'Enter Text Here',
      modifiedHtml:            'Enter Text Here',
      Width:                   552,
      X:                       30,
      Y:                       407,
      elementIndex:            -1,
      editor:                  null,
      locked:                  false,
      type:                    'text',
      scaleX:                  1,
      scaleY:                  1,
      isEditorEnable:          false,
      isSelected:              false,
      isEditableForRightPanel: false,
      fontFamily:              'Ubuntu',
      VerticalAlign:           'Middle',
      fontSize:                16,
      lineSpacing:             1.2,
      color:                   'black',
      isBold:                  false,
      isItalic:                false,
      isUnderline:             false,
      isJustifyCenter:         false,
      isJustifyLeft:           true,
      isJustifyRight:          false,
      verticalAlign:           'top',
      isJustify:               false,
      isBulletList:            false,
      isNumberList:            false,
      isSubScript:             false,
      isSupperScript:          false,
      isTextAdjustmentsNeeded: true,
      valuesForLeftPanel:      {
        fontFamily:      'none',
        fontSize:        16,
        lineSpacing:     1.2,
        color:           'black',
        isBold:          false,
        isItalic:        false,
        isUnderline:     false,
        isJustifyCenter: false,
        isJustifyLeft:   true,
        isJustifyRight:  false,
        verticalAlign:   'top',
        isJustify:       false,
        isBulletList:    false,
        isNumberList:    false,
        isSubScript:     false,
        isSupperScript:  false,
      },
      animation: {
        speed:     50,
        style:     '',
        startTime: 0.0,
        duration:  0.0,
        onEnter:   false,
        onExit:    false,
        distance:  50,
      },
      textShadow: {
        textEffect: 'none',
        angle: 0,
        distance: 0,
        shadowBlur: 0,
        shadowColor: "rgb(252,252,252)",
        transparency: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0
      },
      outLine: {
        textEffect: 'none',
        strokeWidth: 0,
        strokeColor: "#000000"
      },
      isAnimated: false,
    }

    initFromXML(xmlTextObject) {
      const divElement = document.createElement('div');
      // divElement.style.textAlign = xmlTextObject.getElementsByTagName('HorizontalAlign')[0].innerHTML.toLowerCase() === 'middle' ? 'center' : xmlTextObject.getElementsByTagName('HorizontalAlign')[0];
      divElement.innerHTML = xmlTextObject.getElementsByTagName('Value')[0].innerHTML;
      divElement.innerHTML = (divElement.innerText);
      const parentNode     = document.createElement('div');
      document.body.appendChild(parentNode);
      const newElement = parentNode.appendChild(divElement);

      const left = parseFloat(xmlTextObject.getElementsByTagName('X')[0].innerHTML);
      const top  = parseFloat(xmlTextObject.getElementsByTagName('Y')[0].innerHTML);

      this.data.X             = left;
      this.data.Y             = top;
      this.data.Name          = xmlTextObject.getElementsByTagName('Name')[0].innerHTML;
      this.data.PageNo        = parseInt(xmlTextObject.getElementsByTagName('PageNo')[0].innerHTML);
      this.data.Id            = xmlTextObject.getElementsByTagName('Id')[0].innerHTML;
      this.data.AllowMove     = xmlTextObject.getElementsByTagName('AllowMove')[0].innerHTML;
      this.data.AllowResize   = xmlTextObject.getElementsByTagName('AllowResize')[0].innerHTML;
      this.data.AllowRotate   = xmlTextObject.getElementsByTagName('AllowRotate')[0].innerHTML;
      this.data.PdfSortOrder  = parseInt(xmlTextObject.getElementsByTagName('PdfSortOrder')[0].innerHTML);
      this.data.PdfSortOrder += 50;
      this.data.SortOrder     = parseInt(xmlTextObject.getElementsByTagName('SortOrder')[0].innerHTML);
      this.data.Width         = parseInt(xmlTextObject.getElementsByTagName('Width')[0].innerHTML);
      this.data.Height        = parseInt(xmlTextObject.getElementsByTagName('Height')[0].innerHTML);


      this.data.fontSize    = this.data.valuesForLeftPanel.fontSize    = parseFloat(xmlTextObject.getElementsByTagName('FontSize')[0].innerHTML);
      const lineHeight      = parseFloat(xmlTextObject.getElementsByTagName('LineSpacing')[0].innerHTML) + this.data.fontSize;
      this.data.isBold      = this.data.valuesForLeftPanel.isBold      = xmlTextObject.getElementsByTagName('IsBold')[0].innerHTML == 'true';
      this.data.isItalic    = this.data.valuesForLeftPanel.isItalic    = xmlTextObject.getElementsByTagName('IsItalic')[0].innerHTML == 'true';
      this.data.isUnderline = this.data.valuesForLeftPanel.isUnderline = xmlTextObject.getElementsByTagName('IsUnderLine')[0].innerHTML == 'true';

      this.data.verticalAlign = this.data.valuesForLeftPanel.verticalAlign = xmlTextObject.getElementsByTagName('VerticalAlign')[0].innerHTML;

      const horizontalAlign     = xmlTextObject.getElementsByTagName('HorizontalAlign')[0].innerHTML;
      this.data.isJustifyCenter = this.data.valuesForLeftPanel.isJustifyCenter = horizontalAlign.toLowerCase() == 'middle';
      this.data.isJustifyLeft   = this.data.valuesForLeftPanel.isJustifyLeft   = horizontalAlign.toLowerCase() == 'left';
      this.data.isJustifyRight  = this.data.valuesForLeftPanel.isJustifyRight  = horizontalAlign.toLowerCase() == 'right';
      this.data.isJustify       = this.data.valuesForLeftPanel.isJustify  = horizontalAlign.toLowerCase() == 'justify';

      const font = xmlTextObject.getElementsByTagName('Font');
      font.length > 0 && (this.data.fontFamily = this.data.valuesForLeftPanel.fontFamily = font[0].innerHTML);

      // this.data.fontFamily.includes(' - ') && (this.data.fontFamily = this.data.fontFamily.replaceAll(' - ', ' '));
      // this.data.fontFamily.includes('-') && (this.data.fontFamily = this.data.fontFamily.replaceAll('-', ' '));

      const defaultColor = xmlTextObject.getElementsByTagName('DefaultColor')[0].innerHTML;
      this.data.color    = this.data.valuesForLeftPanel.color = (defaultColor.startsWith('cmyk')) ? this.getDefaultColor(defaultColor) : defaultColor;
      // this.data.color    = this.data.valuesForLeftPanel.color = (defaultColor.startsWith('cmyk')) ? this.getDefaultColor(defaultColor) : defaultColor;


      this.data.lineSpacing = this.data.valuesForLeftPanel.lineSpacing = parseFloat(lineHeight / this.data.fontSize).toFixed(1); // convert Px value to number

      if (xmlTextObject.getElementsByTagName('IsHtml')[0].innerHTML == 'false') {
        newElement.innerHTML        = newElement.innerHTML.replaceAll('\n', '<br>');
        newElement.style.fontFamily = this.data.fontFamily;
        xmlTextObject.getElementsByTagName('IsBold')[0].innerHTML == 'true' && (newElement.style.fontStyle = 'bold');
        xmlTextObject.getElementsByTagName('IsItalic')[0].innerHTML == 'true' && (newElement.style.fontStyle = 'italic');
      }
      parentNode.style.width  = `${this.data.Width}px`;
      parentNode.style.height = `${this.data.Height}px`;
      // cause issue on pdf
      // let allBr  = newElement.querySelectorAll('br');
      // let span = document.createElement('span');
      // span.appendChild(document.createElement('br'))
      // for (let i = 0; i<allBr.length; i++) {
      //   allBr[i].outerHTML=`<span style="font-size: ${this.data.parentFontSize}px; line-height: ${this.data.parentFontSize+this.data.LineSpacing}px" > <br> </span>`;
      // }
      // this.applyLineHeightToEachTag(newElement.querySelectorAll('span, font'))

      const textElements = parentNode.firstElementChild.querySelectorAll('span, div, font');
      this.applyFontFamilyToWithOutFontFamilyTag(textElements);
      this.applyStyleToFont(textElements);
      this.convertFontToSpan(parentNode.firstElementChild.querySelectorAll('font'));
      this.data.Value        = this.convertingHtmlCharacterEntities(parentNode.firstElementChild.outerHTML);
      this.data.modifiedHtml = this.data.Value;
      document.body.removeChild(parentNode);
      return this;
    }

    getDefaultColor(color) {
      let rgb = store.getters.getRGBAllNewPmsColors(color);
      if (rgb.startsWith('cmyk')) { rgb = store.getters.getRGBFromBankPMSColorListByCMYK(color); }
      return rgb;
    }

    applyFontFamilyToWithOutFontFamilyTag(allSpans) {
      const fontFmaily =  this.data.fontFamily.replaceAll(/\"/g, '');
      for (let spanIndex = 0; spanIndex < allSpans.length; spanIndex++) {
        const span = allSpans[spanIndex];
        if (!span.style.fontFamily) {
          allSpans[spanIndex].style.fontFamily = (span.parentNode.tagName == 'SPAN' || span.parentNode.tagName == 'FONT') ? 'inherit' : fontFmaily;
        }
        // span.style.fontFamily.includes(' - ') && (span.style.fontFamily = span.style.fontFamily.replaceAll(' - ', ' '));
        // span.style.fontFamily.includes('-') && (span.style.fontFamily = span.style.fontFamily.replaceAll('-', ' '));
      }
    }

    applyStyleToFont(allSpans) {
      for (let i = 0; i < allSpans.length; i++) {
        allSpans[i].hasAttribute('fontsize') && (allSpans[i].style.fontSize = `${parseFloat(allSpans[i].getAttribute('fontsize'))}px`);
        allSpans[i].hasAttribute('color') && (allSpans[i].style.color = allSpans[i].getAttribute('color'));
      }
    }

    convertFontToSpan(allFonts) {
      for (let i = 0; i < allFonts.length; i++) {
        const font         = allFonts[i];
        const span         = document.createElement('span');
        span.innerHTML     = font.innerHTML;
        span.style.cssText = font.style.cssText;
        font.parentNode.insertBefore(span, font);
        font.parentNode.removeChild(font);
      }
    }

    convertingHtmlCharacterEntities(str) {
      if (str.includes('&lt;') || str.includes('&gt;')) {
        return str.replaceAll('&lt;', '<').replaceAll('&gt;', '>');
      }
      return str;
    }
}
